import { TestLocators } from 'constants/Locators';

import { Loader, MUI, ThemeMode } from 'ci-esi-web-shared';

export interface OverlayProps {
  size?: number;
  className?: string;
  testId?: TestLocators | string;
}

export function Overlay({ size, className, testId }: OverlayProps) {
  const theme = MUI.useTheme();
  const isDarkMode = theme.palette.mode === ThemeMode.DARK;

  return (
    <MUI.Box
      className={className}
      data-testid={testId ? `${testId}_Overlay` : undefined}
      sx={{
        position: 'absolute',
        top: 0,
        right: 0,
        width: '100%',
        height: '100%',
        backgroundColor: isDarkMode ? 'rgba(37,37,37,0.5)' : 'rgba(255,255,255,0.5)',
        zIndex: 3,
      }}
    >
      <Loader size={size} />
    </MUI.Box>
  );
}
